type ErrorContentProps = React.PropsWithChildren<object>;

const ErrorContent = (props: ErrorContentProps) => {
  return (
    <>
      <div className="error-container">
        <div className="card">
          <div className="card-body text-black p-0 mb-4">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src="/img/icons/x.svg" className="text-center" alt="errorLogo" height="170" width="170" />
            </div>
            <div className="error-body" role="alert">
              <div className="text-center">{props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorContent;
